import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Confetti from 'react-confetti';
import { Button, Tooltip } from '@trevor/ui-components';
import { get, userAction } from '@/util/helpers/ajax-helpers';
import { loopObject } from '@/util/helpers/object-helpers';
import { safeOnClick } from '@/util/helpers/event-helpers';
import flex from '../css/module/flex.css';
import style from '../css/module/progress.css';

let INSTANCE = null; // instance of this class

const ACTIONS = {
  'use-start-new-query': <span>Start a new query</span>,
  'use-table': (
    <span>
      Open a <b>table</b>
    </span>
  ),
  'use-filter': (
    <span>
      Apply a <b>filter</b> step
    </span>
  ),
  'use-sort': (
    <span>
      Add a <b>sort</b> step
    </span>
  ),
  'use-disable-step': (
    <span>
      <b>Disable</b> your filter step
    </span>
  ),
  'use-summarize': (
    <span>
      Use <b>summarize</b> to count by a dimension
    </span>
  ),
  'use-save-view': (
    <span>
      <b>Save</b> a query
    </span>
  ),
  // 'open-share-page': <span><b>Share</b> a saved query</span>,
  'use-drilldown': (
    <span>
      Click <b>drilldown</b> left of one of the results
    </span>
  ),
  'use-join': (
    <span>
      Add a <b>join</b> step
    </span>
  ),
  'use-hide-columns': (
    <span>
      <b>Hide</b> a column
    </span>
  ),
  'use-rename-columns': (
    <span>
      <b>Rename</b> a column
    </span>
  ),
  'use-reorder-columns': (
    <span>
      <b>Re-order</b> the columns
    </span>
  ),
  'use-custom-expression': (
    <span>
      Add a <b>new column</b>
    </span>
  ),
  'open-sheets-editor': (
    <span>
      Export to <b>Google Sheets</b>
    </span>
  ),
  'use-download': (
    <span>
      <b>Download</b> your results
    </span>
  ),
};

const LEVELS = {
  1: ['use-start-new-query', 'use-table', 'use-filter'],
  2: ['use-disable-step', 'use-summarize', 'use-drilldown'],
  3: ['use-save-view', 'use-download', 'open-sheets-editor'],
  4: ['use-sort', 'use-join', 'use-hide-columns'],
  5: ['use-rename-columns', 'use-reorder-columns', 'use-custom-expression'],
};

const TITLES = {
  1: 'Minute 1: Padawan',
  2: 'Minute 2: Ranger',
  3: 'Minute 3: Wizard',
  4: 'Minute 4: Beast',
  5: 'Minute 5: Legendary',
};

const TOP_LEVEL = Object.keys(TITLES).length + 1; // titles number of keys + 1

function cleanAction(action) {
  switch (action) {
    case 'use-calculate':
    case 'use-inline-AGGREGATE':
      return 'use-summarize';
    default:
      return action;
  }
}

class ProgressChecklist_LEGACY extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: {}, // map of action => true
      newActions: [], // list of actions
      newActionsSeen: [], // list of actions to show user
      showAll: false, // show completed actions
      loading: true,
      levelCompleted: false, // performed action completes level
      done: false, // done all actions (you legend!)
      minimize: true, // boolean
    };
    this.onCompleteLevel = this.onCompleteLevel.bind(this);
    this.toggleMinimize = this.toggleMinimize.bind(this);
  }

  static userActionFired(action) {
    if (INSTANCE) {
      INSTANCE.userActionFired(action);
    }
  }

  componentDidMount() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    INSTANCE = this;
    get('loading progress wizard', '/actions').then((json) => {
      if (!INSTANCE) {
        return; // has been closed
      }
      const actions = {};
      json.map((action) => (actions[cleanAction(action)] = true));
      this.setState({
        actions,
        loading: false,
      });
      if (this.currentLevel() === TOP_LEVEL) {
        this.setState({
          done: true,
        });
      }
    });
  }

  componentWillUnmount() {
    INSTANCE = null;
  }

  currentLevel() {
    // levels looks like this: [1,2,3...]
    const levels = Object.keys(LEVELS);
    for (let i = 0; i < levels.length; i++) {
      const level = levels[i];
      const actions = LEVELS[level]; // an array of actions
      if (actions.some((action) => !this.state.actions[action])) {
        return level; // return the level associated with the first incomplete action
      }
    }
    return TOP_LEVEL;
  }

  onCompleteLevel() {
    this.setState({
      levelCompleted: true,
    });
  }

  // returns progress %;
  progressBar(returnItemsRemaining) {
    const levels = Object.keys(LEVELS);
    let countAll = 0;
    let countAchieved = 0;
    for (let i = 0; i < levels.length; i++) {
      const array = LEVELS[levels[i]];
      array.forEach((action) => {
        countAll += 1;
        if (this.state.actions[action]) {
          countAchieved += 1;
        }
      });
    }
    if (returnItemsRemaining) {
      return countAll - countAchieved;
    }
    return Math.round((countAchieved * 100) / countAll);
  }

  userActionFired(action) {
    action = cleanAction(action);
    if (this.state.levelCompleted) {
      this.setState({
        levelCompleted: false,
      });
    }
    const actions = { ...this.state.actions };
    const newActions = this.state.newActions.slice();
    if (
      !actions[action] &&
      newActions.indexOf(action) === -1 &&
      ACTIONS[action]
    ) {
      newActions.push(action);
      // if action completes current level
      // get the actions in the current level
      const actionsInLevel = LEVELS[this.currentLevel()].slice();
      // see if the action just completed exists in that list
      const i = actionsInLevel.indexOf(action);
      if (i !== -1) {
        // if the action is in the current level, remove it and check the state to see if the other two actions are incomplete. Need to remove it because the state hasn't yet been updated for the action in question.
        actionsInLevel.splice(i, 1);
        const inCompleteLevel = actionsInLevel.some(
          (_action) => !this.state.actions[_action],
        );
        if (!inCompleteLevel) {
          this.onCompleteLevel();
        }
      }
    }
    actions[action] = true;
    this.setState({
      actions,
      newActions,
    });
  }

  // display list of titles and complete / incomplete actions
  items() {
    let allActive = true;
    return loopObject(LEVELS, (level, actions) => {
      const incomplete = LEVELS[level].some(
        (action) => !this.state.actions[action],
      );

      return (
        <div
          key={level}
          className={`${style.level} ${allActive ? '' : style.inactiveLevel}${
            incomplete || this.state.showAll ? '' : style.hide
          }`}
        >
          <h4>
            <b>{TITLES[level]}</b>
          </h4>
          {actions.map((action) => {
            const label = ACTIONS[action];
            allActive = allActive && this.state.actions[action];
            return (
              <div className={style.item} key={action}>
                <span
                  style={{ fontSize: '1.1em', marginTop: '1px' }}
                  className="margin-right-10"
                >
                  {this.state.actions[action] ? (
                    <FontAwesomeIcon
                      className={style.checkbox}
                      icon="check-circle"
                    />
                  ) : (
                    <FontAwesomeIcon className="" icon={['far', 'circle']} />
                  )}
                </span>
                {label}
              </div>
            );
          })}
        </div>
      );
    });
  }

  successMessage(currentLevel) {
    const completedLevel = parseInt(currentLevel, 10) - 1;
    if (completedLevel === 0) {
      return null;
    }
    return null; // currently testing without this
    // return (
    // 	<div className={flex.alignItemsCenter} style={{ paddingLeft: "20px", marginTop: "10px" }}>
    // 		<span className={"strike-through "}><b>{title}</b></span>
    // 		<small className={style.achieved}>DONE</small>
    // 	</div>
    // )
  }

  toggleMinimize() {
    const { minimize } = this.state;
    this.setState({
      minimize: !minimize,
    });
    if (minimize) {
      userAction('open-onboarding-checklist');
    }
  }

  render() {
    if (!this.props.sidebarOpen) {
      return null;
    }

    const { minimize, showAll } = this.state;

    const isMinimized = minimize;

    const currentLevel = this.currentLevel();

    if (this.state.loading || this.state.done) {
      return null;
    }

    return (
      <div className={style.progressOuterContainer}>
        <div className={flex.column}>
          <div className="position-relative w-100">
            {isMinimized && currentLevel !== TOP_LEVEL ? null : (
              <div className={style.progressMaximisedContainer}>
                {currentLevel === TOP_LEVEL ? (
                  <div className="position-relative">
                    <Confetti
                      width={330}
                      height={190}
                      gravity={0.15}
                      opacity={0.25}
                      initialVelocityY={20}
                    />
                  </div>
                ) : null}
                {currentLevel === TOP_LEVEL ? (
                  <div
                    className={`${flex.alignItemsCenter} ${flex.justifyContentCenter}`}
                  >
                    <div className="padding-10 padding-top-20 text-align-center">
                      <b>
                        You've completed all our onboarding challenges - great
                        job!
                      </b>
                      <Button onClick={() => this.setState({ done: true })}>
                        Close and finish
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className={style.progressTitleContainer}>
                    <div
                      className={`${flex.alignItemsCenter} ${flex.justifyContentBetween}`}
                    >
                      <span>
                        <b>Master the basics in 5 minutes</b>
                      </span>
                      <div>
                        {isMinimized || currentLevel === 1 ? null : showAll ? (
                          <span>
                            <span
                              data-tooltip-id="hideAll"
                              className="user-clickable"
                            >
                              <FontAwesomeIcon
                                onClick={safeOnClick(() =>
                                  this.setState({ showAll: !showAll }),
                                )}
                                style={{
                                  fontSize: '1.3em',
                                  color: '#1264a3',
                                  marginRight: '8px',
                                }}
                                icon="check-circle"
                              />
                            </span>
                            <Tooltip id="hideAll" place="left">
                              Hide completed
                            </Tooltip>
                          </span>
                        ) : (
                          <span>
                            <span
                              data-tooltip-id="showAll"
                              className="user-clickable"
                            >
                              <FontAwesomeIcon
                                onClick={safeOnClick(() =>
                                  this.setState({ showAll: !showAll }),
                                )}
                                style={{
                                  fontSize: '1.3em',
                                  marginRight: '8px',
                                }}
                                icon={['far', 'check-circle']}
                              />
                            </span>
                            <Tooltip id="showAll" place="left">
                              Show completed
                            </Tooltip>
                          </span>
                        )}

                        {isMinimized ? (
                          <span>
                            <span
                              data-tooltip-id="maximize"
                              className="user-clickable"
                            >
                              <FontAwesomeIcon
                                onClick={safeOnClick(() =>
                                  this.setState({ minimize: false }),
                                )}
                                style={{ fontSize: '1.3em' }}
                                icon="chevron-circle-up"
                              />
                            </span>
                            <Tooltip id="maximize" place="left">
                              Open
                            </Tooltip>
                          </span>
                        ) : (
                          <span>
                            <span
                              data-tooltip-id="minimize"
                              className="user-clickable"
                            >
                              <FontAwesomeIcon
                                onClick={safeOnClick(() =>
                                  this.setState({ minimize: true }),
                                )}
                                style={{ fontSize: '1.3em' }}
                                icon="chevron-circle-down"
                              />
                            </span>
                            <Tooltip id="minimize" place="left">
                              Minimize
                            </Tooltip>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className={style.progressBarContainer}>
                      <span>{`${this.progressBar()}%`}</span>
                      <span
                        className={flex.grow}
                        style={{ paddingLeft: '10px' }}
                      >
                        <span className={style.progressBar}>
                          <span
                            className={style.progressBarInner}
                            style={{ width: `${this.progressBar()}%` }}
                          />
                        </span>
                      </span>
                    </div>
                  </div>
                )}
                {currentLevel === TOP_LEVEL ? null : (
                  <div className={style.itemsContainer}>
                    {showAll ? null : this.successMessage(currentLevel)}
                    {this.items()}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ProgressChecklist_LEGACY;
